export const authInit = {
  token: '',
  refreshToken: '',
  roles: [],
  username: '',
  id: 0,
  name: '',
  twoFactorAuth: false,
  twoFactorPending: false,
  organisationId: 0,
  organisationMapsApiKey: null,
  organisationName: '',
  companyName: '',
  companyId: 0,
  companyIri: '',
  depotId: 0,
  depotName: '',
  depotIri: '',
  passwordResetAt: 0,
  companyOptions: [],
  emailsEnabled: null,
  countryCode: {
    '@id': '',
    id: 0,
    countryCode: '',
    countryName: '',
  },
}
